import { Link } from "react-router-dom";

export default function Security() {
  return (
    <main className="cv-site">
      <nav className="cv-public-nav">
        <Link to="/" className="cv-public-brand">
          <span className="cv-brand-mark">CV</span>
          <span>CounselVault</span>
        </Link>

        <div className="cv-public-nav-actions">
          <Link to="/" className="cv-nav-link">Home</Link>
          <Link to="/login" className="cv-nav-link">Login</Link>
          <Link to="/register" className="cv-btn cv-btn-primary">Request Access</Link>
        </div>
      </nav>

      <section className="cv-hero-section cv-hero-small">
        <div className="cv-eyebrow">Security Overview</div>
        <h1>Designed around privileged legal mail protection.</h1>
        <p>
          CounselVault is built so legal documents are never served through public bucket URLs,
          CDN links, or unsecured file paths. Access is controlled through application-level
          authorization, audit logging, watermarking, and private storage.
        </p>
      </section>

      <section className="cv-section">
        <div className="cv-card-grid cv-card-grid-2">
          <div className="cv-info-card">
            <h3>No public document URLs</h3>
            <p>
              Documents are stored privately and streamed only after role, facility, inmate,
              and attorney access checks pass.
            </p>
          </div>

          <div className="cv-info-card">
            <h3>Private object storage</h3>
            <p>
              Files are stored in private DigitalOcean Spaces paths organized by facility and inmate.
            </p>
          </div>

          <div className="cv-info-card">
            <h3>Watermarked viewing</h3>
            <p>
              PDFs are fetched privately, watermarked for the viewer, streamed inline, and temporary
              files are deleted automatically.
            </p>
          </div>

          <div className="cv-info-card">
            <h3>MFA-protected staff accounts</h3>
            <p>
              Administrative access is protected with multi-factor authentication before staff can
              manage sensitive workflows.
            </p>
          </div>

          <div className="cv-info-card">
            <h3>Facility-scoped isolation</h3>
            <p>
              Users are scoped to their facility, inmate, attorney profile, and approved access relationships.
            </p>
          </div>

          <div className="cv-info-card">
            <h3>Audit chain integrity</h3>
            <p>
              Security events are logged with chained hashes to help detect tampering and support review.
            </p>
          </div>
        </div>
      </section>

      <section className="cv-section cv-dark-panel">
        <div>
          <span className="cv-kicker">Access model</span>
          <h2>Every view goes through CounselVault first.</h2>
          <p>
            A user cannot simply open a stored PDF. CounselVault validates authorization,
            writes an audit event, applies viewer-specific watermarking, and streams the result.
          </p>
        </div>

        <div className="cv-security-list">
          <div>Attorney approval required</div>
          <div>Inmate access approval required</div>
          <div>Facility review before release</div>
          <div>Revocation enforcement</div>
          <div>Document timeline visibility</div>
          <div>HTTPS transport encryption</div>
        </div>
      </section>

      <section className="cv-cta">
        <h2>Security-first pilot access.</h2>
        <p>Request access for your facility or legal team.</p>
        <Link to="/register" className="cv-btn cv-btn-primary cv-btn-lg">
          Request Access
        </Link>
      </section>
    </main>
  );
}
